import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";
/*** components ***/
import StepStatus from "../../../../components/CarentPageComponents/StepStatus";
import Plan from "../BuildsComponent/Plan";

/*** helpers ***/
import {getParamsOfGrid} from "../../../../helpers/getParamsOfGrid";
import {isAllowLids} from "../../../../helpers/isAllowLids";
import {isAllowSleeve} from "../../../../helpers/isAllowSleeves";

/*** actions ***/
import {pushAddSleeveToSide} from "../../../../actions/pushAddSleeveToSide";
import {deleteSleeveToSide} from "../../../../actions/deleteSleeveToSide";
import {changeNumberOfCells} from "../../../../actions/changeNumberOfCells";

import "../../../../css/BuildSteps/planArea.css";

class PlanArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      planA: {
        numberOfCellsWidth: null,
        numberOfCellsHeight: null,
        sizeOfCell: null,
        areaHeight: null
      },
      item: {}
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.step !== this.props.match.params.step) {
      const dimensions = {
        length: this.props.buildValues.length,
        width: this.props.buildValues.width
      };
      const params = getParamsOfGrid(
        "inner-plan-step-2",
        dimensions,
        this.props.buildValues.height
      );
      this.setState({
        ...params,
        padding: document.body
          .querySelector(".plan-step-2")
          .getBoundingClientRect().left,
        item: {}
      });
    }
  }

  componentDidMount() {
    const dimensions = {
      length: this.props.buildValues.length,
      width: this.props.buildValues.width
    };
    const params = getParamsOfGrid(
      "inner-plan-step-2",
      dimensions,
      this.props.buildValues.height
    );
    this.setState({
      ...params,
      padding: document.body
        .querySelector(".plan-step-2")
        .getBoundingClientRect().left,
      item: {}
    });

    window.onmousemove = e => {
      if (this.resizing) {
        e.preventDefault();
        let height = Math.round(e.pageY - this.initalMouseCoord);
        let size = Math.round(this.state.planA.sizeOfCell / 4);
        if (Math.abs(height) > size) {
          let newCellsHeight = +this.props.buildValues.height;
          this.initalMouseCoord = e.pageY;
          if (height < 0) {
            newCellsHeight += 5;
          } else if (
            this.state.planA.numberOfCellsHeight > 1 &&
            isAllowLids(this.props.match.params.step - 2) &&
            isAllowSleeve()
          ) {
            newCellsHeight -= 5;
          }
          this.props.changeNumberOfCells(newCellsHeight);
        }
      }
    };
    window.onmouseup = e => {
      if (this.resizing) {
        this.resizing = false;
      }
    };
  }

  componentWillUnmount() {
    window.onresize = null;
    window.onmouseup = null;
    window.onmousemove = null;
  }

  startResizing = e => {
    this.resizing = true;
    this.initalMouseCoord = e.pageY;
  };
  /*
  addSleeve = (x, y, background) => {
    const newState = {...this.state.item};
    newState[x + "+" + y] = {background: background};
    this.setState({
      item: {...newState}
    });
    this.props.pushAddSleeveToSide({
      side: +this.props.match.params.step - 2,
      x: x,
      y: y,
      background: background
    });
  };
  deleteSleeve = (x, y) => {
    const newState = {
      ...this.state.item
    };
    delete newState[x + "+" + y];
    this.setState({
      item: {...newState}
    });
    this.props.deleteSleeveToSide({
      side: +this.props.match.params.step - 2,
      x: x,
      y: y
    });
  };
  */

  render() {
    //const isVerticalArrows = this.props.match.params.step === "2" ;
    const isVerticalArrows = true;
    const isPlanOption = this.props.match.params.step === "2";
    const classForPlanArea = this.props.match.params.step === "2" ?
      "plan-area-with-area-options-step-2" :
      "plan-area-without-area-options-step-2";

    return (
      <div className={`plan-area-step-2 ${classForPlanArea}`}>
        <StepStatus
          currentStep={this.props.currentStep}
          isDirect={this.props.buildValues.isVisitedFinish}
        />
        <Plan
          bottom={"50%"}
          borderColor={"#ffffff"}
          dataInputName="height"
          areaName={"planA"}
          isVerticalArrow={isVerticalArrows}
          isInput={true}
          numberOfCellsWidth={this.state["planA"].numberOfCellsWidth}
          sizeOfCell={this.state["planA"].sizeOfCell}
          changeInputValue={this.props.changeInputValue}
          startResizing={this.startResizing}
          /*
          addSleeve={this.addSleeve}
          deleteSleeve={this.deleteSleeve}
          */
          currentStep={this.props.currentStep}
        />
        {/*
        {isPlanOption ? (
          <div className="plan-area-options-step-2">
            <h2 className={"main-options-header-step-1"}>
              DIMENSIONEN (Zentimeter)
            </h2>
            <ul className={"main-options-options-step-1"}>
              {mainOptionsList.map((item, index) => {
                return (
                  <MainOption
                    key={item.optionName}
                    optionName={item.optionName}
                    index={index}
                    type={item.type}
                    step={5}
                    value={this.props.buildValues[item.dataInputName]}
                    changeInputValue={this.props.changeInputValue}
                    dataInputName={item.dataInputName}
                  />
                );
              })}
            </ul>
          </div>
        ) : null}
        {isPlanOption ? <div className={"empty-space-step-2"} /> : null}
        */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    buildValues: state.buildValues,
    buildValuesSides: state.buildValuesSides
  };
};
const mapStateToDispatch = {
  pushAddSleeveToSide,
  deleteSleeveToSide,
  changeNumberOfCells
};

PlanArea.propTypes = {
  buildValues: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    length: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    changeInputValue: PropTypes.func,
    currentStep: PropTypes.number,
    pushAddSleeveToSide: PropTypes.func,
    deleteSleeveToSide: PropTypes.func,
    buildValuesSides: PropTypes.arrayOf(PropTypes.object)
  })
};

export default withRouter(
  connect(mapStateToProps, mapStateToDispatch)(PlanArea)
);



// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/PlanArea/PlanArea.js